import isEmpty from '../../utility/isEmpty'

export default {
  getStoreById: (state) => (storeId) => {
    return state.stores[storeId]
  },

  getStoreInfo: (state, getters) => (storeId) => {
    const store = getters.getStoreById(storeId)
    return isEmpty(store) ? undefined : store.storeInfo
  },

  getBrandConfig: (state, getters) => (storeId) => {
    const store = getters.getStoreById(storeId)
    return isEmpty(store) ? undefined : store.brandConfig
  },

  getStoreBrand: (state, getters) => (storeId) => {
    const store = getters.getStoreById(storeId)
    return isEmpty(store) || isEmpty(store.brandConfig) ? undefined : store.brandConfig.brandName
  },

  getStoreAddress: (state, getters) => (storeId) => {
    const store = getters.getStoreById(storeId)
    return isEmpty(store) || isEmpty(store.storeInfo) ? undefined : store.storeInfo.address
  },

  getStoreHoursRaw: (state, getters) => (storeId) => {
    const store = getters.getStoreById(storeId)
    return isEmpty(store) || isEmpty(store.storeInfo) ? undefined : store.storeInfo.hoursRaw
  },

  getStoreImage: (state, getters) => (storeId) => {
    const store = getters.getStoreById(storeId)
    return isEmpty(store) || isEmpty(store.storeInfo) ? undefined : store.storeInfo.image
  },

  getStorePhoneNumber: (state, getters) => (storeId) => {
    const store = getters.getStoreById(storeId)
    return isEmpty(store) || isEmpty(store.storeInfo) ? undefined : store.storeInfo.phone
  },

  getStoreState: (state, getters) => (storeId) => {
    const store = getters.getStoreById(storeId)
    return isEmpty(store) || isEmpty(store.storeInfo) || isEmpty(store.storeInfo.state) ? undefined : store.storeInfo.state.label
  },

  getStoreStateAbrev: (state, getters) => (storeId) => {
    const store = getters.getStoreById(storeId)
    return isEmpty(store) || isEmpty(store.storeInfo) || isEmpty(store.storeInfo.state) ? undefined : store.storeInfo.state.value
  },

  getStoreNumber: (state, getters) => (storeId) => {
    const store = getters.getStoreById(storeId)
    return isEmpty(store) || isEmpty(store.storeInfo) ? undefined : store.storeInfo.id
  }
}
